export const recentUpdates = [
  {
    id: 'u1',
    type: '动态',
    tone: 'primary',
    period: '近期',
    title: '新片方向整理更新',
    summary:
      '围绕近期公开的作品方向补充整理条目，重点标注题材归类与观看顺序，方便想快速了解新片脉络的读者按线索浏览。',
  },
  {
    id: 'u2',
    type: '写真',
    tone: 'accent',
    period: '本季',
    title: '写真与影像合集补录',
    summary:
      '新增写真与影像主题条目，按氛围、色调与外景类型划分，补充说明各合集适合的浏览场景，方便按偏好挑选。',
  },
  {
    id: 'u3',
    type: '活动',
    tone: 'secondary',
    period: '阶段',
    title: '活动信息公开归档',
    summary:
      '把线下见面、线上直播与合作联动三类公开信息分类归档，标注参与方式方向与注意事项，便于提前安排。',
  },
  {
    id: 'u4',
    type: '消息',
    tone: 'primary',
    period: '近期',
    title: '消息核对方式补充',
    summary:
      '整理常见消息来源类型与核对步骤，帮助区分官方发布、媒体转述与网友二次加工内容，减少误读。',
  },
  {
    id: 'u5',
    type: '近况',
    tone: 'accent',
    period: '持续',
    title: '近况三线汇总',
    summary:
      '把近况拆成作品、写真、活动三条线索分别汇总，先给整体节奏，再给细分方向，方便对照参考。',
  },
];